// import { useEffect, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import EmptyState from 'assets/EmptyState.svg';
import Button from 'components/Common/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { onBoarding } from 'routes/config';
// import { useGetBusinessProfile } from 'apis/business/hook';
// import Spinner from 'components/Common/Spinner';
// import { useStripeCheckout } from 'apis/business/setting/billing/hook';
// import { isSubscriptionActive } from 'utils/helperFunctions';
import * as urls from 'routes/config';

export default function CreateAgent() {
  const navigate = useNavigate();
  const { workspaceId } = useParams();

  // const { data: businessProfile, isLoading, isError } = useGetBusinessProfile();

  // const { data: stripeCheckoutData, mutateAsync: initiateStripeCheckout } = useStripeCheckout();

  // const subscriptionActive = useMemo(
  //   () => isSubscriptionActive(businessProfile?.stripe_subscription_active_till),
  //   [businessProfile?.stripe_subscription_active_till]
  // );

  // useEffect(() => {
  //   if (!subscriptionActive && !isLoading && !isError) {
  //     initiateStripeCheckout();
  //   }
  // }, [initiateStripeCheckout, subscriptionActive, isLoading, isError]);

  const handleButtonClick = () => {
    // if (!subscriptionActive) {
    //   window.location.href = stripeCheckoutData?.checkout_url || '';
    // } else {
    //   navigate(`${urls.base(workspaceId)}/${onBoarding.selectAgent}`);
    // }
    navigate(`${urls.base(workspaceId)}/${onBoarding.selectAgent}`);
  };

  // if (isLoading) {
  //   return <Spinner />;
  // }

  return (
    <Box
      sx={{
        height: 'calc(100vh - 112px)', // calculated from onboard layout
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f9f9f9'
      }}
    >
      <Box sx={{ textAlign: 'center', borderRadius: '8px' }}>
        <img src={EmptyState} alt='empty-state' width={80} height={80} />
        <Typography variant='h2' gutterBottom my={2}>
          Add your first agent
        </Typography>
        <Button variant='contained' fullWidth onClick={handleButtonClick}>
          Create Agent
        </Button>
      </Box>
    </Box>
  );
}
